<div class="bg-tl-blue h-14"></div>

<div class="bg-tl-grey py-6 px-6">
  <div class="container mx-auto">
    <div class="flex flex-col gap-4 md:flex-row md:items-end md:justify-between">
      <div class="space-y-1">
        <p class="text-tl-dark-blue font-bold text-xl">Company Leaderboard</p>
        <p class="text-gray-500 text-sm">
          Aggregated player performance across all games
        </p>
      </div>

      <button
        type="button"
        (click)="loadLeaderboard()"
        [disabled]="isLoading"
        class="w-fit shadow-[2px_2px_0px_0px_rgba(137,137,137,1)] text-white rounded-[1.5rem] text-sm px-6 font-bold py-2 bg-tl-button-blue focus:outline-none disabled:opacity-50"
      >
        @if (isLoading) {
          Refreshing...
        } @else {
          Refresh
        }
      </button>
    </div>
  </div>
</div>

<div class="container mx-auto text-black py-6 px-6">
  <!--
  <div class="grid grid-cols-1 md:grid-cols-3 gap-4 mb-6">
    <div class="bg-white rounded-lg border border-gray-200 p-5">
      <p class="text-gray-500 text-sm font-medium">Players</p>
      <p class="text-tl-dark-blue text-2xl font-bold mt-1">
        {{ totalPlayers | number }}
      </p>
    </div>

    <div class="bg-white rounded-lg border border-gray-200 p-5">
      <p class="text-gray-500 text-sm font-medium">Games Played</p>
      <p class="text-tl-dark-blue text-2xl font-bold mt-1">
        {{ totalGamesPlayed | number }}
      </p>
    </div>

    <div class="bg-white rounded-lg border border-gray-200 p-5">
      <p class="text-gray-500 text-sm font-medium">Total Score</p>
      <p class="text-tl-dark-blue text-2xl font-bold mt-1">
        {{ totalScore | number }}
      </p>
    </div>
  </div>
  -->

  <div class="bg-white rounded-xl border p-6">
    <div class="flex flex-col gap-4 md:flex-row md:items-center md:justify-between mb-6">
      <div>
        <h2 class="text-xl font-bold text-tl-dark-blue">Leaderboard</h2>
        <!-- @if (lastUpdated) {
          <p class="text-gray-500 text-sm mt-1">
            Last updated {{ lastUpdated | date: 'medium' }}
          </p>
        } -->
      </div>

      <div class="flex flex-col gap-2 sm:flex-row sm:items-center">
        <input
          type="text"
          placeholder="Search by email..."
          [(ngModel)]="searchTerm"
          (ngModelChange)="onSearchChange($event)"
          (keydown.enter)="onSearch()"
          class="font-medium lg:w-80 shadow-[2px_2px_0px_0px_rgba(137,137,137,1)] border sm:text-sm rounded focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 placeholder-gray-400 text-black focus:outline-none"
        />

        <button
          type="button"
          (click)="onSearch()"
          [disabled]="isLoading"
          class="px-4 py-2 bg-tl-button-blue text-white rounded-lg font-semibold hover:bg-opacity-90 transition-colors disabled:opacity-50"
        >
          Search
        </button>

        @if (searchTerm) {
          <button
            type="button"
            (click)="clearSearch()"
            [disabled]="isLoading"
            class="px-4 py-2 border border-gray-300 text-gray-700 rounded-lg font-semibold hover:bg-gray-50 transition-colors disabled:opacity-50"
          >
            Clear
          </button>
        }
      </div>
    </div>

    @if (errorMessage) {
      <div class="mb-5 rounded-lg border border-red-200 bg-red-50 px-4 py-3 text-sm text-red-700">
        {{ errorMessage }}
      </div>
    }

    <div class="max-h-[70vh] overflow-auto">
      <table class="w-full table-fixed text-left border-collapse">
        <thead>
          <tr class="text-gray-500 border-b border-gray-200">
            <th class="sticky top-0 z-10 w-[10%] bg-white py-3 px-4 font-semibold text-sm">
              Rank
            </th>
            <th class="sticky top-0 z-10 w-[16%] bg-white py-3 px-4 font-semibold text-sm">
              Name
            </th>
            <th class="sticky top-0 z-10 w-[22%] bg-white py-3 px-4 font-semibold text-sm">
              Email
            </th>
            <th class="sticky top-0 z-10 w-[22%] bg-white py-3 px-4 font-semibold text-sm">
              Learner ID
            </th>
            <th class="sticky top-0 z-10 w-[15%] bg-white py-3 px-4 font-semibold text-sm">
              Games Played
            </th>
            <th class="sticky top-0 z-10 w-[15%] bg-white py-3 px-4 font-semibold text-sm">
              Highest Score
            </th>
          </tr>
        </thead>
        <tbody>
          @if (isLoading) {
            <tr>
              <td colspan="6" class="py-12 text-center text-gray-500">
                <div class="flex flex-col items-center justify-center gap-3">
                  <app-loading-spinner></app-loading-spinner>
                  <span>Loading leaderboard...</span>
                </div>
              </td>
            </tr>
          } @else {
            @for (player of leaderboard; track trackByLearnerId($index, player)) {
              <tr class="border-b border-gray-100 hover:bg-gray-50">
                <td class="py-3 px-4 text-sm text-gray-800 font-bold">
                  #{{ player.rank || $index + 1 }}
                </td>
                <td class="py-3 px-4 text-sm text-gray-800 font-semibold">
                  {{ player.name || '-' }}
                </td>
                <td class="py-3 px-4 text-sm text-gray-600">
                  {{ player.email || '-' }}
                </td>
                <td class="py-3 px-4 text-sm text-gray-600">
                  {{ player.learnerId || '-' }}
                </td>
                <td class="py-3 px-4 text-sm text-gray-700">
                  {{ (player.gamesPlayed || 0) | number }}
                </td>
                <td class="py-3 px-4 text-sm text-gray-800 font-bold">
                  {{ (player.totalScore || 0) | number:'1.0-0' }}
                </td>
              </tr>
            } @empty {
              <tr>
                <td colspan="6" class="py-8 text-center text-gray-500">
                  No leaderboard data found.
                </td>
              </tr>
            }
          }
        </tbody>
      </table>
    </div>

    <div class="mt-5 flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
      <p class="text-sm text-gray-500">
        Showing {{ currentPageStart | number }}-{{ currentPageEnd | number }}
        of {{ totalCount | number }}
      </p>

      <div class="flex items-center gap-3">
        <button
          type="button"
          (click)="previousPage()"
          [disabled]="isLoading || !hasPreviousPage"
          class="px-4 py-2 border border-gray-300 text-gray-700 rounded-lg font-semibold hover:bg-gray-50 transition-colors disabled:opacity-50"
        >
          Previous
        </button>

        <span class="text-sm text-gray-600">
          Page {{ page | number }} of {{ totalPages | number }}
        </span>

        <button
          type="button"
          (click)="nextPage()"
          [disabled]="isLoading || !hasNextPage"
          class="px-4 py-2 bg-tl-button-blue text-white rounded-lg font-semibold hover:bg-opacity-90 transition-colors disabled:opacity-50"
        >
          Next
        </button>
      </div>
    </div>
  </div>
</div>
